module.exports = __webpack_public_path__ + "static/app_image-5e6ef78a308971c9fe09448593b22316.png";